<div id="smart-send-map-container">
  <mgl-map
    [style]="styleUrl"
    [zoom]="[Zoom]"
    [center]="center"
    [transformRequest]="transformReq"
    class="map"
    (load)="onMapReady($event)"
    [cursorStyle]="cursorStyle"
  >
    <!-- search box -->
    <mgl-control>
      <div
        [class.d-none]="!isShowSearchBar"
        class="sm:tw-w-[450px] tw-w-[300px] md:tw-static sm:tw-static lg:tw-absolute tw-right-[50px] move-right"
      >
        <map-search-box (search)="getSelectedFilterPlace($event)">
        </map-search-box>
      </div>

      <div
        [class.d-none]="!isShowSearchPlaces"
        class="sm:tw-w-[450px] tw-w-[300px] md:tw-static sm:tw-static lg:tw-absolute tw-right-[50px] move-right"
        [ngClass]="isShowSearchBar?'tw-top-[60px]':''"
      >
        <map-places-grid
          (layerData)="getSelectedPlace($event)"
          (selectedPlace)="zoomOnSelectedPlace($event)"
        >
        </map-places-grid>
      </div>
    </mgl-control>

    <mgl-control>
      <div class="mapboxgl-ctrl-group">
        <button
          type="button"
          title="{{ 'common.collapseMap' | translate}}"
          aria-label="Collapse map"
          aria-disabled="false"
          *ngIf="!isExpandMap"
          (click)="emitExpandCollapseMap('expand')"
        >
          <i class="save-icon mdi mdi-arrow-collapse"></i>
        </button>

        <button
          type="button"
          title="{{ 'common.expandMap' | translate}}"
          aria-label="Expand map"
          aria-disabled="false"
          *ngIf="isExpandMap"
          (click)="emitExpandCollapseMap('collapse')"
        >
          <i class="save-icon mdi mdi-arrow-expand"></i>
        </button>
      </div>
    </mgl-control>

    <mgl-control mglNavigation> </mgl-control>

    <mgl-control>
      <div class="mapboxgl-ctrl-group">
        <button
          type="button"
          [title]=" 'common.search' | translate"
          aria-label="Add Search"
          aria-disabled="false"
          (click)="isShowSearchBar=!isShowSearchBar"
        >
          <i class="save-icon mdi mdi-20px mdi-magnify"></i>
        </button>
        <button
          type="button"
          [title]=" 'common.searchPlace' | translate"
          aria-label="Add Search place"
          aria-disabled="false"
          (click)="isShowSearchPlaces=!isShowSearchPlaces"
        >
          <i class="save-icon mdi mdi-18px mdi-mosque ignore-dark-color"></i>
        </button>
        <button
          type="button"
          [title]=" 'common.addPublicPlace' | translate"
          aria-label="Add Public Place"
          aria-disabled="false"
          (click)="onPublicPlaceButtonClick()"
          *ngIf="ShowAddPublicPlace"
        >
          <i
            class="save-icon mdi mdi-18px mdi-map-marker-plus ignore-dark-color"
          ></i>
        </button>
        <button
          type="button"
          [title]=" 'common.addToPublicPlace' | translate"
          aria-label="Add To Public Place"
          aria-disabled="false"
          (click)="onAddToPublicPlaceButtonClick()"
          *ngIf="ShowAddToPublicPlace"
        >
          <i class="save-icon mdi mdi-18px mdi-home-plus ignore-dark-color"></i>
        </button>
        <button
          *ngIf="ShowSaveButton"
          type="button"
          title="{{ 'common.savePolygon' | translate}}"
          aria-label="Save Polygon"
          aria-disabled="false"
          (click)="onSaveButtonClick($event)"
        >
          <i
            class="mdi mdi-20px mdi-shape-polygon-plus tw-text-pink-500 ignore-dark-color"
          ></i>
        </button>
        <button
          type="button"
          title="{{ 'common.help' | translate}}"
          aria-label="Help"
          aria-disabled="false"
          (click)="onHelpButtonClick($event)"
        >
          <i
            class="save-icon mdi mdi-18px mdi-help-circle ignore-dark-color"
          ></i>
        </button>
      </div>
    </mgl-control>

    <mgl-geojson-source
      id="polygon-source"
      [data]="DisplayPolygon"
    ></mgl-geojson-source>
    <mgl-layer
      id="display-polygon-area"
      type="fill"
      source="polygon-source"
      [paint]="{
          'fill-color': DisplayPolygonFillColor,
          'fill-opacity' : DisplayPolygonFillOpacity
        }"
    ></mgl-layer>
  </mgl-map>
  
</div>
